import { useState } from "react";
import React from 'react';
import PropTypes from 'prop-types';
import "./ImageSlider.css";

export function ImageSlider({ imageURLs }) {
    const [imageIndex, setImageIndex] = useState(0);

    const nextImage = (change) => {
        let newIndex = imageIndex + change;
        if (newIndex === -1) {
            newIndex = imageURLs.length - 1;
        } else if (newIndex === imageURLs.length) {
            newIndex = 0;
        }
        setImageIndex(newIndex);
    };

    return (
        <div className="slideshow-container">
            <div style={{ width: "100%", height: "100%", display: "flex", overflow: "hidden" }}>
                {imageURLs.map((media, idx) => {
                    // Handle legacy string-based images
                    if (typeof media === "string") {
                        return (
                            <img 
                                key={idx} 
                                src={media} 
                                className="prj-image" 
                                style={{ translate: `${-100 * imageIndex}%` }} 
                                alt={`Slide ${idx}`} 
                            />
                        );
                    }

                    // Handle object-based media
                    if (media.type === "image") {
                        return (
                            <img 
                                key={idx} 
                                src={media.src} 
                                className="prj-image" 
                                style={{ translate: `${-100 * imageIndex}%` }} 
                                alt={`Slide ${idx}`} 
                            />
                        );
                    }

                    if (media.type === "video") {
                        return (
                            <video 
                                key={idx} 
                                controls 
                                className="prj-image" 
                                style={{ translate: `${-100 * imageIndex}%` }}
                            >
                                <source src={media.src} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        );
                    }

                    return null;  // fallback
                })}
            </div>

            <button id="next" className="slider-button" onClick={() => nextImage(1)}>{">"}</button>
            <button id="prev" className="slider-button" onClick={() => nextImage(-1)}>{"<"}</button>
        </div>
    );
}

ImageSlider.propTypes = {
    imageURLs: PropTypes.array.isRequired
};
